import { getCreator, postCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  POST_REPORT: `${environment.apiUrl}/report`,
  POST_ATTACHMENT: `${environment.apiUrl}/report/attachment`,
  GET_REPORT_MOTIVES_AVAILABLE: `${environment.apiUrl}/meta/report-motives/AVAILABLE_ORDERS`,
  GET_REPORT_MOTIVES_PURCHASER: `${environment.apiUrl}/meta/report-motives/PURCHASER_TRACKING`,
  GET_REPORT_MOTIVES_TRAVELER: `${environment.apiUrl}/meta/report-motives/TRAVELER_TRACKING`,
});

export const postReportApi = postCreator(fetch, endpoints.POST_REPORT);
export const uploadAttachmentApi = postCreator(fetch, endpoints.POST_ATTACHMENT);
export const fetchReportMotivesAvailableApi = getCreator(fetch, endpoints.GET_REPORT_MOTIVES_AVAILABLE);
export const fetchReportMotivesPurchaserApi = getCreator(fetch, endpoints.GET_REPORT_MOTIVES_PURCHASER);
export const fetchReportMotivesTravelerApi = getCreator(fetch, endpoints.GET_REPORT_MOTIVES_TRAVELER);



// WEBPACK FOOTER //
// ./src/modules/report/api.js